import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { emptySpeciality, Speciality } from "../../../../interfaces/speciality";
import { useEffect, useState } from "react";
import { deleteSpeciality, getSpecialitiesSingle } from "../../../../services/speciality";
import { Trans } from "react-i18next";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminSpecialityDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminSpecialityDelete(props: AdminSpecialityDeleteProps) {
    const [speciality, setSpeciality] = useState<Speciality>(emptySpeciality);

    const handleDelete = () => {
        deleteSpeciality(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Speciality cannot be deleted. Modalities of this epeciality exist."));
                    props.onClose();
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        debugger;
        getSpecialitiesSingle(props.id)
            .then(response => {
                setSpeciality(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-speciality-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_speciality") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { speciality.id == 0 && 
                    <LoadingSpinner />
                }
                { speciality.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_speciality_message"
                                values={{
                                    speciality_name: speciality.name, 
                                    speciality_code: speciality.code
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}